import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { CreaCorrispondenzaPartenzaDTO } from "@app/shared/dto/gescor/crea-corrispondenza-partenzaDTO";
import { FormCreaCorrispondenzaPartenzaVO } from "@app/shared/vo/gescor/form-crea-corrispondenza-partenzaVO";
import { MapperUtente } from "../mapper-utente";
import { MapperSettore } from "../mapper-settore";
import { MapperDestinatarioInterno } from "./mapper-destinatario-interno";
import { MapperDestinatario } from "./mapper-destinatario";
import { MapperDestinatarioDipendente } from "./mapper-destinatario-dipendente";
import { MapperDocumentoToDocumentoGescor } from "./mapper-documento-to-documento-gescor";


@Injectable({
  providedIn: "root",
})
export class MapperCreaCorrispondenzaPartenza
  implements
  MapperInterface<
    CreaCorrispondenzaPartenzaDTO,
    FormCreaCorrispondenzaPartenzaVO
  > {
  constructor(
    private mapperDocumentoGescor: MapperDocumentoToDocumentoGescor,
    private mapperUtente: MapperUtente,
    private mapperSettore: MapperSettore,
    //   private mapperVisibilitaPartenza: MapperVisibilitaPartenza,
    private mapperDestinatariInterni: MapperDestinatarioInterno,
    private mapperDestinatari: MapperDestinatario,
    private mapperDestinatarioDipendente: MapperDestinatarioDipendente /*   private mapperDatiFirmaPartenza: MapperDatiFirmaPartenza */
  ) { }

  convertVoToDto(
    e: FormCreaCorrispondenzaPartenzaVO
  ): CreaCorrispondenzaPartenzaDTO {
    console.log("[MapperCorrispondenzaPartenza] convertVoToDto ", e);
    const creaCorrispondenzaPartenzaDTO = new CreaCorrispondenzaPartenzaDTO();

    creaCorrispondenzaPartenzaDTO.destinatariInterni = this.mapperDestinatariInterni.convertListVoToDto(
      e.destinatariInterni
    );
    creaCorrispondenzaPartenzaDTO.destinatari = this.mapperDestinatari.convertListVoToDto(
      e.formDestinatari.destinatari
    );
    creaCorrispondenzaPartenzaDTO.destinatariCartacei = this.mapperDestinatari.convertListVoToDto(
      e.formDestinatariCartacei.destinatari
    );

    creaCorrispondenzaPartenzaDTO.destinatariDipendenti = this.mapperDestinatarioDipendente.convertListVoToDto(
      e.destinatariDipendenti
    );

    if (e.firmatario !== null && e.firmatario !== undefined) {
      creaCorrispondenzaPartenzaDTO.firmatario = this.mapperUtente.convertVoToDto(
        e.firmatario
      );
    }

    if (e.settoreFirmatario !== null && e.settoreFirmatario !== undefined) {
      creaCorrispondenzaPartenzaDTO.settoreFirmatario = this.mapperSettore.convertVoToDto(
        e.settoreFirmatario
      );
    }
    creaCorrispondenzaPartenzaDTO.mittente = this.mapperSettore.convertVoToDto(e.settoreFirmatario);
    creaCorrispondenzaPartenzaDTO.tipoProtocollo = e.tipoProtocollo;
    creaCorrispondenzaPartenzaDTO.primario = this.mapperDocumentoGescor.convertVoToDto(e.primario);
    creaCorrispondenzaPartenzaDTO.allegati = this.mapperDocumentoGescor.convertListVoToDto(e.allegati);
    creaCorrispondenzaPartenzaDTO.oggetto = e.oggetto;



    return creaCorrispondenzaPartenzaDTO || new CreaCorrispondenzaPartenzaDTO();
  }

  convertDtoToVo(
    e: CreaCorrispondenzaPartenzaDTO
  ): FormCreaCorrispondenzaPartenzaVO {
    // console.log("[MapperCorrispondenzaPartenza.convertDtoToVo] dto:", e);
    const creaCorrispondenzaPartenzaVO = new FormCreaCorrispondenzaPartenzaVO();
    return creaCorrispondenzaPartenzaVO;
  }
  convertListVoToDto(
    e: FormCreaCorrispondenzaPartenzaVO[]
  ): CreaCorrispondenzaPartenzaDTO[] {
    const creaCorrispondenzaPartenzaDTOList = new Array<
      CreaCorrispondenzaPartenzaDTO
    >();
    if (e != null) {
      e.forEach((corrPartenza) => {
        creaCorrispondenzaPartenzaDTOList.push(
          this.convertVoToDto(corrPartenza)
        );
      });
    }

    return (
      creaCorrispondenzaPartenzaDTOList ||
      new Array<CreaCorrispondenzaPartenzaDTO>()
    );
  }

  convertListDtoToVo(
    t: CreaCorrispondenzaPartenzaDTO[]
  ): FormCreaCorrispondenzaPartenzaVO[] {
    const creaCorrispondenzaPartenzaVOList = new Array<
      FormCreaCorrispondenzaPartenzaVO
    >();
    if (t != null) {
      t.forEach((corrPartenza) => {
        creaCorrispondenzaPartenzaVOList.push(
          this.convertDtoToVo(corrPartenza)
        );
      });
    }

    return (
      creaCorrispondenzaPartenzaVOList ||
      new Array<FormCreaCorrispondenzaPartenzaVO>()
    );
  }
}
